/*
 *   Icon
 */

$class: ".gov-icon";

#{$class} {
	display: inline-flex;
	height: 1em;

	&__holder {
		display: inline-flex;
		width: 100%;
		height: 100%;

		& + #{$class}__holder {
			display: none !important;
		}
	}
	svg {
		display: inline-flex;
		width: 100%;
		height: 100%;
		max-width: 100%;
		max-height: 100%;
	}
}
